const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://fobxubw2aa.execute-api.us-west-2.amazonaws.com/prod',
    TEAM_API_URL: 'https://dz3tgvxslk.execute-api.us-west-2.amazonaws.com/api'
  },
  reactApp: {
    VERSION: 'taxonomy-teams-1.15.5',
    HOSTNAME: 'https://teams-service.teck.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.teck.forwoodsafety.com',
    WEBSOCKET: 'wss://cvh1lv5wmh.execute-api.us-west-2.amazonaws.com/prod'
  },
};

export default config;
